import { render, staticRenderFns } from "./CCDefault.vue?vue&type=template&id=58f75477&"
import script from "./CCDefault.vue?vue&type=script&lang=js&"
export * from "./CCDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports